import React from "react";
import { Helmet } from "react-helmet";
import "./DesignFAQ.css";

const faqs = [
  {
    question: "What is included in Oglitz design packages?",
    answer:
      "Each design package includes professionally crafted visuals such as social media creatives, branding assets, and design support. Exact deliverables depend on the selected package and are clearly listed before ordering.",
  },
  {
    question: "How long does it take to deliver a design package?",
    answer:
      "Delivery timelines vary by package. Basic packages typically take 7–10 days, while advanced or monthly packages may run for 30 days with ongoing design support.",
  },
  {
    question: "Can I request revisions on designs?",
    answer:
      "Yes. All packages include at least one revision per design. Higher-tier packages include multiple revisions to ensure complete satisfaction.",
  },
  {
    question: "Are these design packages suitable for startups?",
    answer:
      "Absolutely. Our design packages are created specifically for startups, growing businesses, and established brands looking to improve visual identity and online presence.",
  },
  {
    question: "Do you provide custom or monthly design packages?",
    answer:
      "Yes. We offer custom and monthly design plans tailored to your brand goals, design volume, and ongoing marketing needs.",
  },
];

const DesignFAQ = () => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((faq) => ({
      "@type": "Question",
      name: faq.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: faq.answer,
      },
    })),
  };

  return (
    <section className="oglitz-design-faq" aria-labelledby="design-faq-title">
      {/* SEO Schema */}
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      </Helmet>

      <header className="oglitz-design-faq__header">
        <span className="oglitz-design-faq__badge">FAQs</span>

        <h2 id="design-faq-title" className="oglitz-design-faq__title">
          Frequently Asked{" "}
          <span className="oglitz-design-faq__title-accent">Questions</span>
        </h2>

        <p className="oglitz-design-faq__subtitle">
          Everything you need to know about our design packages, process,
          pricing, and delivery.
        </p>
      </header>

      <div className="oglitz-design-faq__list">
        {faqs.map((faq, index) => (
          <details key={index} className="oglitz-design-faq__item">
            <summary className="oglitz-design-faq__question">
              {faq.question}
            </summary>
            <p className="oglitz-design-faq__answer">{faq.answer}</p>
          </details>
        ))}
      </div>
    </section>
  );
};

export default DesignFAQ;
